import qs from 'qs';

export default function buildBreakdownDrillUrl({
  surveyId,
  dimension,
  propertyKey,
  rowValue,
  savedSearchId,
}) {
  if (dimension === 'saved_searches' && savedSearchId) {
    return `/surveys/${surveyId}/saved-searches/${savedSearchId}`;
  }

  const query = {};
  if (dimension === 'tags') {
    query['tags[0]'] = rowValue;
  } else if (dimension === 'group') {
    query['group[0]'] = rowValue;
  } else if (dimension === 'property' && propertyKey) {
    query[`person_properties.${propertyKey}[0]`] = rowValue;
  }

  const qsString = qs.stringify(query);
  return qsString ? `/surveys/${surveyId}/?${qsString}` : `/surveys/${surveyId}/`;
}
